// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "app" + "." + "b3e9d093f6c04fad7be0" + ".css";
};